export enum Route {
  Home = '/',
}
